export default __webpack_public_path__ + "static/media/actionNoResult.c184c403.svg";